import { render } from "./UserQueryMaster.vue?vue&type=template&id=1b758a24&scoped=true"
import script from "./UserQueryMaster.vue?vue&type=script&lang=js"
export * from "./UserQueryMaster.vue?vue&type=script&lang=js"

import "./UserQueryMaster.vue?vue&type=style&index=0&id=1b758a24&scoped=true&lang=css"
import "./UserQueryMaster.vue?vue&type=style&index=1&id=1b758a24&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b758a24"]])

export default __exports__